import styled from 'styled-components';

const Wrapper = styled.footer`
  height: 14rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  background: var(--clr-black);
  text-align: center;
  position: relative;
  
  span {
    color: var(--clr-primary-5);
  }
  h5 {
    color: var(--clr-grey-6);
    font-weight: 400;
    text-transform: none;
    line-height: 1.25;
  }
  .footerLinks a {
    text-decoration: none;
    color: var(--clr-grey-6);
    padding: 0.8rem;
  }
  .footerLinks a:hover {
    color: var(--clr-primary-5);
  }
  .footerSocialLinks,
  .footerLinks {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  .footerSocialLinks {
    margin-top: 1.5rem;
  }
  .footerSocialLinks a {
    cursor: pointer;
  }
  .footerLinks {
    margin-bottom: 1.5rem;
    margin-top: 1rem;
  }
  .underline {
    width: 95%;
    height: 1px;
    margin-bottom: 1rem;
    background: var(--clr-grey-7);
  }
  svg {
    margin: 0.7rem;
  }

  /* Phone Dialog Styles */
  .phone-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }

  .phone-dialog {
    background: white;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    min-width: 280px;
    position: relative;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    animation: slideIn 0.3s ease;
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .phone-dialog h4 {
    color: var(--clr-grey-1);
    margin-bottom: 1rem;
    font-size: 1.25rem;
  }

  .phone-dialog .phone-number {
    font-size: 1.75rem;
    font-weight: bold;
    color: var(--clr-primary-5);
    margin-bottom: 1.5rem;
    letter-spacing: 2px;
  }

  .phone-dialog .copy-btn {
    background: var(--clr-primary-5);
    color: white;
    border: none;
    padding: 0.75rem 2rem;
    border-radius: 8px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .phone-dialog .copy-btn:hover {
    background: var(--clr-primary-7);
    transform: translateY(-2px);
  }

  .phone-dialog .close-dialog {
    position: absolute;
    top: 10px;
    right: 15px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--clr-grey-5);
    transition: color 0.3s ease;
  }

  .phone-dialog .close-dialog:hover {
    color: var(--clr-grey-1);
  }

  @media (min-width: 776px) {
    flex-direction: column;
  }
`;

export default Wrapper;
